// extracted by mini-css-extract-plugin
module.exports = {"icon":"oJcgiVsssqZFknv4aJPml","link":"AKdRkkze69VIUAjmuF9t2","active":"_1r_T0NREBJmdZPsv5yU1qa"};